import React from 'react';
import './Loading.css';

const Loading = ({ size = 'medium', text = 'Loading...', subtext = 'Please wait while we prepare your experience' }) => {
  return (
    <div className="loading-container">
      {/* Floating particles */}
      <div className="loading-particles">
        <div className="loading-particle"></div>
        <div className="loading-particle"></div>
        <div className="loading-particle"></div>
        <div className="loading-particle"></div>
        <div className="loading-particle"></div>
      </div>
      
      <div className="loading-content">
        {/* Logo */}
        <div className="loading-logo">
          <div className="loading-logo-icon">
            <span style={{ color: 'white', fontWeight: 'bold', fontSize: '1.5rem' }}>E</span>
          </div>
          <span className="loading-logo-text">E-Commerce</span>
        </div>

        {/* Spinner */}
        <div className="loading-spinner">
          <div className="loading-spinner-ring"></div>
          <div className="loading-spinner-ring"></div>
          <div className="loading-spinner-ring"></div>
          <div className="loading-spinner-ring"></div>
        </div>

        {/* Text */}
        <div className="loading-text">{text}</div>
        <div className="loading-subtext">{subtext}</div>

        {/* Animated dots */}
        <div className="loading-dots">
          <div className="loading-dot"></div>
          <div className="loading-dot"></div>
          <div className="loading-dot"></div>
        </div>

        {/* Progress bar */}
        <div className="loading-progress">
          <div className="loading-progress-bar"></div>
        </div>
      </div>
    </div>
  );
};

export default Loading; 